import React from 'react';
import LazyMetrics from '../../states-year/LazyMetrics';
import EngagementByMonth from '../../states-year/Educators/EngagementByMonth';
import SharedProject from '../../states-year/Educators/SharedProject';
import SharedEvent from '../../states-year/Educators/SharedEvent';
import InvitedToOffer from '../../states-year/Educators/InvitedToOffer';
import InvitedToOfferAndResponded from '../../states-year/Educators/InvitedToOfferAndResponded';
import CreatedInviteToOffer from '../../states-year/Educators/CreatedInviteToOffer';
import EducatorGrowthByMonth from '../../states-year/Educators/EducatorGrowthByMonth';
import CompositeEducatorGrowth from '../../states-year/Educators/CompositeEducatorGrowth';
import EducatorStatusYear from '../../states-year/Educators/EducatorStatusYear';

export default function Educators(props) {
  const { params } = props;

  return (
    <>
      <LazyMetrics
        title="Educators"
        columns={1}
      >
        {/*<EducatorGrowthByMonth {...params} />*/}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <EducatorStatusYear {...params} />
        </div>
        <EducatorGrowthByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <CompositeEducatorGrowth {...params} titleOnly={true} />
        </div>
      </LazyMetrics>
      <LazyMetrics title="Educator Engagement" columns={1}>
        <EngagementByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <SharedProject {...params} titleOnly={true} />
          <SharedEvent {...params} titleOnly={true} />
          <InvitedToOffer {...params} titleOnly={true} />
          <InvitedToOfferAndResponded {...params} titleOnly={true} />
          <CreatedInviteToOffer {...params} titleOnly={true} />
        </div>
      </LazyMetrics>
    </>
  );
}
